import React from 'react';

import SideMenu from '../../components/SideMenu';

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
      };
  }

  componentDidMount() {
  }

  render() {
   return (
    <section id="userPage">
      <SideMenu />

      <div className="contentData">
        <div className="contentScroll">
          <div className="contentSubData">
            <span className="desktop">
              <br/>
              <p className="title"><span style={{fontWeight: "normal"}}>Dashboard |</span> Dashboard</p><br/>
            </span>

            <span className="mobile">
              <br/>
              <p className="title"><span style={{fontWeight: "normal"}}>Dashboard |</span> Dashboard</p><br/>
            </span>
          </div>
        </div>
      </div>
    </section>
   );
  }
 }

export default Item;
